__turbopack_context__.v({
  "default": "ValidationItem-module-scss-module__kbqwka__default",
  "error": "ValidationItem-module-scss-module__kbqwka__error",
  "item": "ValidationItem-module-scss-module__kbqwka__item",
  "success": "ValidationItem-module-scss-module__kbqwka__success",
});
